import { Component, inject } from '@angular/core';
import { OktaCallbackComponent } from '@okta/okta-angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-custom-okta-callback',
  standalone: true,
  template: '<span></span>',
})
export class CustomCallbackComponent extends OktaCallbackComponent {
  private router = inject(Router);

  override async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    if (this.error?.includes('AuthSdkError')) {
      await this.router.navigate(['/']);
    }
  }
}
